import { z } from 'zod';

export const RUNTIME_ROW_TYPE = {
  TODO: 'TODO',
  FORM: 'FORM',
} as const;

export const runtimeRowTypeSchema = z.enum([
  RUNTIME_ROW_TYPE.TODO,
  RUNTIME_ROW_TYPE.FORM,
]);

export type RuntimeRowType = z.infer<typeof runtimeRowTypeSchema>;

export type OpenRuntimeRow = {
  id: string;
  rowType: RuntimeRowType;
};
